import useUserStore from "@/store/modules/user.js";

const channel = new BroadcastChannel("auth_channel");

channel.onmessage = (event) => {
  if (event.data === "logout") {
    useUserStore().logoutLocal();
    window.location.href = "/login";
  }
};

export const notifyOtherTabsLogout = () => {
  channel.postMessage("logout");
};
